<template>
  <div class="mushroom-page">
    <!-- 1. 顶部Banner（满屏背景+文字） -->
    <section class="hidden md:block banner relative w-full overflow-hidden">
      <img src="@/assets/product/Rectangle_18.png" alt="食用菌Banner" class="w-full h-full object-cover">
      <!-- 文字遮罩 -->
      <div class="absolute inset-0 bg-black/20"></div>
      <!-- 标题内容 -->
      <div class="absolute inset-0 text-center text-white z-10 top-[20%]">
        <h1 class="text-[clamp(2.5rem,5vw,4rem)] font-bold mb-3">菌中之王，鲜不过季</h1>
        <p class="text-[clamp(0.9rem,2vw,1rem)]">
          规划 100+ 智能方仓，五大品类错峰入仓、全年连续生产。
        </p>
      </div>
    </section>
    <section class="block md:hidden relative w-full overflow-hidden h-[80vh]">
      <!-- 背景图 -->
      <img src="@/assets/product/mb_bg3.png" class="absolute inset-0 w-[100%] h-[100%]" alt="" />
      <!-- 深色遮罩提升文字可读性 -->
      <div class="absolute inset-0 bg-black/15"></div>

      <div class="relative z-10 w-full pt-[20%] px-6 flex flex-col items-center text-white">
        <img src="@/assets/logo_H.png" alt="菌丰生物" class="mb-6">
        <!-- 主标题 -->
        <h2 class="text-[24px] font-bold mb-2 text-center">菌中之王，鲜不过季</h2>
        <!-- 描述文字 -->
        <p class="text-[10px] leading-6 text-center opacity-90 mb-10">
          规划 100+ 智能方仓，五大品类错峰入仓、全年连续生产。
        </p>
      </div>
      <!-- 底部两个按钮卡片 -->
      <div class="w-full grid grid-cols-2 gap-2 absolute bottom-0 left-0 z-10">
        <div style="background-color: rgba(255, 255, 255, 0.35)" @click="goPage('/product/2')"
          class="bg-opacity-35 py-4 pl-4 flex justify-between items-center text-white">
          <div>
            <p class="text-sm font-medium">蘑菇仓</p>
            <p class="text-[8px] whitespace-nowrap">Mushroom Growing Chamber</p>
          </div>
          <span class="text-xl mr-2">→</span>
        </div>
        <div style="background-color: rgba(255, 255, 255, 0.35)" @click="goPage('/product/1')"
          class="bg-opacity-35 py-4 pl-4 flex justify-between items-center text-white">
          <div>
            <p class="text-sm font-medium">菌菇</p>
            <p class="text-[8px]">Mushroom</p>
          </div>
          <span class="text-xl mr-2">→</span>
        </div>
      </div>
    </section>
    <!-- 2. 菌种介绍区 -->
    <section class="md:py-16 py-6 md:max-w-[56%] max-w-[94%] mx-auto px-4">
      <!-- 菌种大图 -->
      <div class="relative mb-8">
        <div class="md:block hidden absolute bottom-10 right-10">
          <span class="text-white/50 text-5xl font-bold px-6 py-2">
            食用菌种-蘑菇
          </span>
        </div>
        <!-- <img 
          src="@/assets/product/Rectangle_23.png" 
          alt="食用菌种-蘑菇" 
          class="w-full h-auto"
        > -->
        <video class="w-full h-auto object-cover" autoplay loop muted playsinline>
          <source src="@/assets/video/home2.mp4" type="video/mp4" />
        </video>
      </div>

      <!-- 香菇标题+介绍 -->
      <div class="md:flex">
        <div class="md:w-[40%] w-full">
          <h2 class="text-[#41B56F] font-bold mb-2 md:ml-10 md:text-left text-center">{{ datalist[id - 1].name }}</h2>
          <p class="text-[#666666] text-xs leading-relaxed mb-4 md:ml-10 md:text-left text-center">
            {{ datalist[id - 1].tips }}
          </p>

          <!-- 查看更多产品按钮 -->
          <button
            class="bg-[#41B56F] block md:ml-10 mx-auto text-white text-xs px-4 py-1 mb-10 hover:bg-green-700 transition">
            查看更多产品
          </button>
        </div>
        <div class="hidden md:block w-[60%]">
          <div class="flex justify-around">
            <div class="flex flex-col items-center item1">
              <div class="rounded-l border border-gray-200 border-solid px-3 py-1 text-center relative z-10">
                <h3 class="text-[#41B56F] text-lg font-bold mb-1">营养丰富</h3>
                <div class="triangle"></div>
              </div>
            </div>
            <div class="flex flex-col items-center item2">
              <div class="rounded-l border border-gray-200 border-solid px-3 py-1 text-center relative z-10">
                <h3 class="text-[#41B56F] text-lg font-bold mb-1">生态友好</h3>
                <div class="triangle"></div>
              </div>
            </div>
            <div class="flex flex-col items-center item3">
              <div class="rounded-l border border-gray-200 border-solid px-3 py-1 text-center relative z-10">
                <h3 class="text-[#41B56F] text-lg font-bold mb-1">风味独特</h3>
                <div class="triangle"></div>
              </div>
            </div>
            <div class="flex flex-col items-center item4">
              <div class="rounded-l border border-gray-200 border-solid px-3 py-1 text-center relative z-10">
                <h3 class="text-[#41B56F] text-lg font-bold mb-1">增强免疫</h3>
                <div class="triangle"></div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
    <section class=" md:max-w-[56%] max-w-[94%] mx-auto md:py-8 py-4 px-4">
      <img :src="datalist[id - 1].img" alt="产品图片" class="w-full h-auto rounded-lg">
    </section>
  </div>
</template>

<script>
export default {
  name: "Product1Page",
  data() {
    return {
      id: 1,
      datalist: [
        {
          name: '香菇',
          tips: '香菇栽培技术成熟、市场容量大，单位面积产量高，抗逆性强，是保障基础产能和降低市场风险的可靠品种。',
          img: require("@/assets/product/XG.jpg")
        },
        {
          name: '秀珍菇',
          tips: '秀珍菇生长周期短、资金周转快，是项目的核心产量品种。秀珍菇对温度要求较高，通过智慧方仓实现恒温恒湿调控，可突破传统季节性种植限制。',
          img: require("@/assets/product/XZG.jpg")
        },
        {
          name: '金耳',
          tips: '金耳珍稀名贵、药食同源、多糖含量居食用菌之首，在方舱精准环控下可实现全年高密度、高周转、无农药生产，且具备冻干、化妆品原料等高附加值深加工延展能力。',
          img: require("@/assets/product/JE.jpg")
        },
        {
          name: '舞茸菌',
          tips: '舞茸菌是珍稀食药用菌，属恒温型中温性木腐菌，生产周期约1个月，出菇管理20至30天。',
          img: require("@/assets/product/WRJ.jpg")
        },
        {
          name: '双孢菇',
          tips: '双孢菇作为栽培技术成熟、市场需求稳定的大众化品种，单位面积产量高、盈利能力强。',
          img: require("@/assets/product/SBG.jpg")
        }
      ]
    };
  },
  mounted() {
    // 页面加载时滚动到顶部
    this.id = this.$route.query.id;
  },

   methods: {
    goPage(path) {
      this.$router.push(path);
    },
  },
}
</script>

<style scoped>
/* 仅保留必要过渡 */
button {
  border: none;
  cursor: pointer;
}

/* 小三角 */
.triangle {
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
  width: 14px;
  height: 14px;
  background: white;
  border-right: 2px solid #e5e7eb;
  border-bottom: 2px solid #e5e7eb;
  z-index: 11;
}

/* 核心动画：从下往上弹 */
@keyframes up1 {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }

  30% {
    opacity: 1;
    transform: translateY(0);
  }

  70% {
    opacity: 1;
    transform: translateY(0);
  }

  100% {
    opacity: 0;
    transform: translateY(20px);
  }
}

@keyframes up2 {
  0% {
    opacity: 0;
    transform: translateY(40px);
  }

  30% {
    opacity: 1;
    transform: translateY(-8px);
  }

  70% {
    opacity: 1;
    transform: translateY(-8px);
  }

  100% {
    opacity: 0;
    transform: translateY(40px);
  }
}

@keyframes up3 {
  0% {
    opacity: 0;
    transform: translateY(30px);
  }

  30% {
    opacity: 1;
    transform: translateY(-15px);
  }

  70% {
    opacity: 1;
    transform: translateY(-15px);
  }

  100% {
    opacity: 0;
    transform: translateY(30px);
  }
}

@keyframes up4 {
  0% {
    opacity: 0;
    transform: translateY(25px);
  }

  30% {
    opacity: 1;
    transform: translateY(-5px);
  }

  70% {
    opacity: 1;
    transform: translateY(-5px);
  }

  100% {
    opacity: 0;
    transform: translateY(25px);
  }
}

@keyframes up5 {
  0% {
    opacity: 0.4;
    transform: translateY(45px);
  }

  30% {
    opacity: 0;
    transform: translateY(-12px);
  }

  50% {
    opacity: 1;
    transform: translateY(-12px);
  }

  70% {
    opacity: 0;
    transform: translateY(-12px);
  }

  100% {
    opacity: 0.4;
    transform: translateY(45px);
  }
}

/* 依次动画 + 真实高低错落 */
.item1>div {
  animation: up1 2s infinite;
  animation-delay: 0s;
}

.item2>div {
  animation: up2 2s infinite;
  animation-delay: 0.2s;
}

.item3>div {
  animation: up3 2s infinite;
  animation-delay: 0.4s;
}

.item4>div {
  animation: up4 2s infinite;
  animation-delay: 0.2s;
}

.item5>div {
  animation: up5 2s infinite;
  animation-delay: 0s;
}
</style>